import { List, Record } from 'immutable'
import moment from 'moment'
import { AssociatedContact, IAssociatedContact } from './AssociatedContact'

export interface IEarnestMoney {
  readonly depositDate?: number
  readonly amount: number
  readonly holdingLocation: string
  readonly withdrawlDate?: number
}

const EarnestMoneyRecord = Record({
  amount: 0,
  depositDate: undefined,
  holdingLocation: '',
  withdrawlDate: undefined,
})

export class EarnestMoney extends EarnestMoneyRecord implements IEarnestMoney {
  public static fromJS(initialState?: Partial<IEarnestMoney>) {
    return new EarnestMoney(initialState)
  }

  public readonly depositDate?: number
  public readonly amount: number
  public readonly holdingLocation: string
  public readonly withdrawlDate?: number

  constructor(initialState?: Partial<EarnestMoney>) {
    initialState ? super(initialState) : super()
  }
}
